import styled from "styled-components";
import { COLOUR_CONSTANT } from "../../utils/contants";

export const SearchHeaderStyled = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 36px;
  border-bottom: 1px solid ${COLOUR_CONSTANT.theme.lightPink};
  height: 52px;
  position: sticky;
  top: 56px;

  .search-field {
    width: 45%;
  }
  .heading {
    font-weight: bold;
  }
`;
